import { useEffect, useMemo, useState } from 'react'
import { useQueryParams } from './use-query-params'
import { initialPagination } from 'data/const'
import { debounce } from 'lodash'
import { showHttpToast } from 'lib/show-toast'

export function useDataList({ listService, transformFilters, initialQueryParams, tableFields }) {
    const { queryParams, ...fns } = useQueryParams({ initialQueryParams, tableFields })
    const [data, setAdjudicatarios] = useState([])
    const [pagination, setPagination] = useState(initialPagination)
    const [initializing, setInitializing] = useState(true)
    const [loading, setLoading] = useState(false)

    const load = useMemo(
        () =>
            debounce(async (queryParams) => {
                setLoading(true)
                const params = {
                    ...queryParams,
                    filter: transformFilters
                        ? transformFilters(queryParams.filter ?? {})
                        : queryParams.filter,
                }
                const { success, message, data } = await listService(params)
                if (success) {
                    setAdjudicatarios(data.data)
                    setPagination(data.pagination)
                } else {
                    showHttpToast(success, { description: message })
                }
                setLoading(false)
                if (initializing) setInitializing(false)
            }, 300),
        [],
    )

    useEffect(() => {
        load(queryParams)
    }, [queryParams])

    return { data, pagination, queryParams, initializing, loading, ...fns }
}
